import { render, staticRenderFns } from "./ParticipantsForEventGrid.vue?vue&type=template&id=491a169f"
import script from "./ParticipantsForEventGrid.vue?vue&type=script&lang=js"
export * from "./ParticipantsForEventGrid.vue?vue&type=script&lang=js"
import style0 from "./ParticipantsForEventGrid.vue?vue&type=style&index=0&id=491a169f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports